import React from 'react';
import { createRoot } from "react-dom/client";
import './css/index.css';
import App from './App';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <>
    <ToastContainer 
    position="top-right"
    autoClose={3000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss={false}
    draggable
    pauseOnHover={false}
    theme="light"
    />
    <App/>
  </>
);
